import { AutoMap } from "@automapper/classes";
import { CountryDto } from "./country.dto";

export class CountryResponseDto {

    @AutoMap()
  public content!: CountryDto[];

}